import type { Components, Theme } from '@mui/material';

export const MuiAutocomplete: Components<Theme>['MuiAutocomplete'] = {
  styleOverrides: {
    root: () => ({
      '& .MuiOutlinedInput-root': {
        '& .MuiAutocomplete-input': {
          padding: '0',
        },
      },
    }),

    paper: () => ({
      fontSize: '1.4rem',
    }),
  },
};
